import { PanelGroup, Panel } from 'bee-panel'

Panel.PanelGroup = PanelGroup

export default Panel
